import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapObjectHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Object;
    }
}

//# sourceMappingURL=WrapObjectHelper.js.map
